<template>
  <button  class="flex flex-row justify-center space-x-4 py-2  font-bold">
       <!-- <span class="my-auto  text-2xl text-warmGray-50 ">  Basket </span> -->
        <div class="relative">
            <img v-if="cartIcon"  class="w-10 h-10" src="../assets/bilder/cart.svg" alt="Cart Icon">
              <span class="btn-circle bg-warmGray-50 text-namasteRed " v-if="hasProduct">
                {{ totalCartItems }}
              </span>
        </div>
  </button>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    totalCartItems: Number,
    cartIcon: Boolean,
    hasProduct: Boolean
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      cartTotal: 'getFormCartTotal',
      lieferkosten: 'getLieferKosten'

    })
  }
}
</script>

<style scoped>

.btn-circle {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    padding-top: 2px;
    position: absolute;
    right: -1.2rem;
    top: -0.6rem;

}
</style>
